import React, { useRef } from 'react'
import './Navbar.css'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useState } from 'react';
import { useEffect } from 'react';
import styled from 'styled-components';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
export default function Navbar() {
  const NavbarContainer = styled.nav`
  {
    position: fixed;
    display: grid;
    grid-template-columns: auto 2fr;
    top: 0;
    justify-content: space-between;
    align-items: center;
    padding: 0 5vw;
    width: 100%;
    height: 3.8em;
    background: rgba(0, 0, 0, 0.9);
    z-index: 1000;
    & #logo {
      font-size: 1.8rem;
      padding: 0.3em 0;
      text-decoration: none;
      font-weight: bolder;
      color: white;
      font-family: 'Joyride STD';
      cursor:pointer;
    }
    & #logo:hover {
      color: #eaf765;
    } 
  }`;

  const [navChecked, setNavChecked] = useState(true);
  const toggleNavCheck = () => {
    setNavChecked(prev => !prev);
  }
  const [dropDown, setDropDown] = useState('hidden');

  const toggleDropDown = () => {
    if (dropDown === 'hidden') {
      setDropDown('visible');
    } else {
      setDropDown('hidden');
    }
  }

  useEffect(() => {
    function handleResize() {
      if (window.screen.width >= 1002) {
        setNavChecked(true);
      }
      if (window.screen.width <= 1001) {
        setNavChecked(false);
      }
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });

  return (
    <NavbarContainer id='nav-container' className='bg-black padding-x-half'>
      <a href="/" id="logo"><i> MAKE</i></a>
      <div className="wrapper nav-wrapper" style={{ display: navChecked ? 'flex' : 'none' }}>
        <div id="navbar" className="full-bleed">
          <li className="item" id="item1"><Link to="/about" className="nav-item nav-item-color">About Us</Link></li>
          <li className="item" id="item2"><Link to="/website" className="nav-item nav-item-color" >Websites</Link></li>
          {/* <li className="item dropbtn dropdown" id="item2">
            <a className="nav-item active" href="/"><span className='flex-1'>Our Services</span></a>
            <i className="fa-solid fa-caret-down" onClick={toggleDropDown} />
            <div className={`dropdown-content ${dropDown}`}>
              <li className='dropdown-item'><Link to="/website">Websites</Link></li>
              <li className='dropdown-item'><a href="/">Social Media</a></li>
              <li className='dropdown-item'><a href="/">Creative Content</a></li>
              <li className='dropdown-item'><a href="/">Paid Marketing</a></li>
              <li className='dropdown-item'><a href="/">Search & SEO</a></li>
            </div>
          </li> */}
          <li className="item" id="item3"><Link to="/case-studies" className="nav-item nav-item-color">Case Studies</Link></li>
          {/* <li className="item" id="item4"><Link to="/website" className="nav-item nav-item-color">Blog</Link></li> */}
          <li className="item" id="item4"><Link to="/careers" className="nav-item nav-item-color">Careers</Link></li>
          <li className="item" id="item5"><a className="nav-item nav-item-color" href="/">Contact Us</a></li>
        </div>
        <Link className='btn yellow-button' id='nav-yellow-btn' to="/start-project" style={{ display: navChecked ? 'flex' : 'none' }}>Start Your Project</Link>
      </div>
      {/* <CircularProgressbar /> */}
      <label htmlFor="menu-check-box" id='nav-check' >
        <input type="checkbox" name="menu-check" id="menu-check-box" style={{ display: 'none' }} onClick={() => toggleNavCheck()} />
        <span className='check'></span>
        <span className='check'></span>
        <span className='check'></span>
      </label>
      {/* </CircularProgressbar> */}
    </NavbarContainer >
  )
}
Navbar.propTypes = {
  logo: PropTypes.string.isRequired,
  siteTitle: PropTypes.string
}
// Navbar.propTypes = { logo: PropTypes.string, 
// siteTitle: PropTypes.string }
Navbar.defaultProps = {
  logo: "siteLogo",
  siteTitle: "site Title"
}
